import { DeptUserBaseStoreProvider } from '../BaseStore'

import { DeptUserCascaderCore } from './Core'
import { DeptUserCascaderProps } from './interface'

export const DeptUserCascader = <M extends boolean>({
  /* -------------------------------------------------------------------------- */
  /*                         DeptUserCascaderCore Props                         */
  /* -------------------------------------------------------------------------- */
  allowClear,
  autoFocus,
  disabled,
  placeholder,

  /* -------------------------------------------------------------------------- */
  /*                       DeptUserBaseStoreProvider Props                      */
  /* -------------------------------------------------------------------------- */
  strictMode,
  multiple,
  value,
  onChange
}: DeptUserCascaderProps<M>) => {
  return (
    <DeptUserBaseStoreProvider
      triggerChangeWhenSelect
      multiple={multiple}
      strictMode={strictMode}
      value={value}
      onChange={onChange}
    >
      <DeptUserCascaderCore
        allowClear={allowClear}
        autoFocus={autoFocus}
        disabled={disabled}
        placeholder={placeholder}
      />
    </DeptUserBaseStoreProvider>
  )
}
